import loadable from '@loadable/component'

export const Error = loadable(() => import('./Error'))
export type { ErrorProps } from './Error'
